export default __webpack_public_path__ + "static/media/bin.d5a72f4d.svg";